<h2 mat-dialog-title>{{ title }}</h2>
<mat-dialog-content>{{ content }}</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button [mat-dialog-close]="false">{{ negativeText }}</button>
  <button mat-button [mat-dialog-close]="true">{{ positiveText }}</button>
</mat-dialog-actions>
